import loadable from "@loadable/component";

export const Dashboard = loadable(() => import("pages/dashboard"));
export const Conversations = loadable(() => import("pages/conversations"));
export const login = loadable(() => import("pages/login"));
export const Feed = loadable(() => import("pages/vkinnectFeed"));
export const FeedCreate = loadable(
  () => import("pages/vkinnectFeed/createPost")
);
export const Branches = loadable(
  () => import("pages/configuration/settings/branches")
);
export const WarehouseLocations = loadable(
  () => import("pages/configuration/settings/warehouseLocations")
);
export const ServiceCategory = loadable(
  () => import("pages/configuration/settings/serviceCategory")
);
export const ServiceType = loadable(
  () => import("pages/configuration/settings/serviceCategory/serviceType")
);
export const Services = loadable(
  () => import("pages/configuration/settings/services")
);
export const ServiceDetail = loadable(
  () => import("pages/configuration/settings/services/serviceDetail")
);
export const ServicePackageDetail = loadable(
  () =>
    import("pages/configuration/settings/servicePackges/servicePackageDetail")
);
export const Locker = loadable(
  () => import("pages/configuration/settings/locker")
);
export const ServicePackages = loadable(
  () => import("pages/configuration/settings/servicePackges")
);
export const Volunteers = loadable(() => import("pages/vkinnectVolunteers"));
export const VKinnectUsers = loadable(() => import("pages/vkinnectUsers"));
export const VolunteerDetails = loadable(
  () => import("pages/vkinnectVolunteers/volunteerDetails")
);
export const BasicInformation = loadable(
  () => import("pages/vkinnectVolunteers/volunteerDetails/basic_Information")
);
export const ServiceInformation = loadable(
  () => import("pages/vkinnectVolunteers/volunteerDetails/service_Information")
);
export const LocationInformation = loadable(
  () => import("pages/vkinnectVolunteers/volunteerDetails/location_Information")
);
export const KycInformation = loadable(
  () => import("pages/vkinnectVolunteers/volunteerDetails/kyc_Information")
);
export const Documentation = loadable(
  () => import("pages/vkinnectVolunteers/volunteerDetails/documentation")
);
export const AssociateBookings = loadable(
  () => import("pages/vkinnectVolunteers/volunteerDetails/associateBookings")
);
export const ServiceBooking = loadable(() => import("pages/serviceBooking"));
export const ServiceBookingsLayout = loadable(
  () => import("pages/serviceBooking/ServiceBookingsLayout")
);
export const FamilyCare = loadable(
  () => import("pages/serviceBooking/FamilyCare")
);
export const PropertyCare = loadable(
  () => import("pages/serviceBooking/PropertyCare")
);
export const ShopInIndia = loadable(
  () => import("pages/serviceBooking/ShopInIndia")
);
export const ServiceBookingDetails = loadable(
  () => import("pages/serviceBooking/bookingView")
);
export const ServiceInfo = loadable(
  () => import("pages/serviceBooking/bookingView/serviceInformation")
);
export const BookingTimeline = loadable(
  () => import("pages/serviceBooking/bookingView/timelineInfo")
);
export const AdditionalServiceInfo = loadable(
  () => import("pages/serviceBooking/bookingView/additionalServiceInfo")
);
export const QuotationTab = loadable(
  () => import("pages/serviceBooking/bookingView/quotation/QuotationTab")
);
export const PaymentInformation = loadable(
  () => import("pages/serviceBooking/bookingView/paymentInformation")
);
export const ServiceFeed = loadable(
  () => import("pages/serviceBooking/bookingView/serviceFeed")
);
export const CancellationRequestsTab = loadable(() =>
  import("pages/serviceBooking/bookingView/BookingRequests").then((m) => ({
    default: m.CancellationRequestsTab,
  }))
);
export const SupportRequestsTab = loadable(() =>
  import("pages/serviceBooking/bookingView/BookingRequests").then((m) => ({
    default: m.SupportRequestsTab,
  }))
);
export const EmergencyAlert = loadable(() => import("pages/emergencyAlerts"));
export const EmergencyAlertDetail = loadable(
  () => import("pages/emergencyAlerts/detail")
);
export const Admin = loadable(() => import("pages/admin"));
export const ManageAdmins = loadable(
  () => import("pages/configuration/settings/manageAdmins")
);
export const ManageManagers = loadable(
  () => import("pages/configuration/settings/manageManagers")
);
export const Users = loadable(
  () => import("pages/configuration/settings/users")
);
export const UserDetail = loadable(
  () => import("pages/configuration/settings/users/detail")
);
export const PermissionMatrix = loadable(
  () => import("pages/configuration/settings/permissionMatrix")
);

export const UserDetails = loadable(
  () => import("pages/vkinnectUsers/UserDetails")
);

export const UserFamily = loadable(
  () => import("pages/vkinnectUsers/family")
);

export const UserInformation = loadable(
  () => import("pages/vkinnectUsers/UserInformation")
);

export const UserProperty = loadable(
  () => import("pages/vkinnectUsers/UserProperty")
);

export const ShopForYourself = loadable(
  () => import("pages/shopForYourself")
);
